function ifNoCustomThenDefault(custom, def) {
    return custom ? custom : def
}

function trueOrNull(proposition) {
    return proposition ? true : null;
}

export { ifNoCustomThenDefault, trueOrNull }